import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import { Message } from 'element-ui';
import MemberEdit from '../../member/info2/index';
import ParentsEdit from '../../memberTourists/parents/index';
export default {
  components: {
    MemberEdit: MemberEdit,
    ParentsEdit: ParentsEdit
  },
  name: 'agencyTouristsMemberList',
  data: function data() {
    return {
      parentDialogVisible: false,
      pushMessageDisable: false,
      pushMessageDialogVisible: false,
      addCurrencyDisable: false,
      addCurrencyDialogVisible: false,
      addMemberDisable: false,
      addMembeDialogVisible: false,
      isSelect: this.checkauthority('agency_tourists_select'),
      isCreate: this.checkauthority('tourists_add'),
      isUpdate: this.checkauthority('tourists_edit'),
      isDelete: this.checkauthority('tourists_del'),
      isSelectMemberInfo: this.checkauthority('select_tourists_info_edit'),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      activeName: 'default',
      selectForm: {
        registerTime: [],
        memberTime: [],
        nickName: '',
        sex: '',
        name: '',
        headUrl: '',
        phone: '',
        userName: '',
        passWord: '',
        wxMiniOpenid: '',
        loginTime: null,
        loginNum: null,
        loginDevice: '',
        province: '',
        city: '',
        area: '',
        longitude: '',
        latitude: '',
        vAuth: '',
        memberType: '',
        privateLetterNum: null,
        acceptNum: null,
        memberStartTime: null,
        memberEndTime: null,
        warningsNum: null,
        currencyNum: null,
        memberSts: null,
        createTime: null,
        memberNo: '',
        source: '',
        sortType: 1,
        startAge: null,
        endAge: null,
        education: null,
        marriage: null,
        carPurchase: null,
        buyHouse: null,
        noOrPhone: null,
        selectCitys: [],
        authentication: '',
        membership: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      provinces: [],
      citys: [],
      sex: [],
      memberV: [],
      memberTypes: [],
      memberSources: [],
      minAges: [],
      maxAges: [],
      educations: [],
      carPurchases: [],
      buyHouses: [],
      marriages: [],
      getAuthentications: []
    };
  },
  methods: {
    toParents: function toParents(data) {
      this.$refs.parents.setTitle('访客详情');
      this.editDisabled = true;
      this.parentDialogVisible = true;
      this.$refs.parents.setData(data);
    },
    parentsEditClose: function parentsEditClose() {
      this.parentDialogVisible = false;
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nickName: this.selectForm.nickName,
        sex: this.selectForm.sex,
        name: this.selectForm.name,
        headUrl: this.selectForm.headUrl,
        phone: this.selectForm.phone,
        userName: this.selectForm.userName,
        vAuth: this.selectForm.vAuth,
        memberType: this.selectForm.memberType,
        privateLetterNum: this.selectForm.privateLetterNum,
        acceptNum: this.selectForm.acceptNum,
        memberStartTime: this.selectForm.memberStartTime,
        memberEndTime: this.selectForm.memberEndTime,
        warningsNum: this.selectForm.warningsNum,
        currencyNum: this.selectForm.currencyNum,
        memberSts: this.selectForm.memberSts,
        memberNo: this.selectForm.memberNo,
        source: this.selectForm.source,
        sortType: this.selectForm.sortType,
        endAge: this.selectForm.endAge,
        startAge: this.selectForm.startAge,
        marriage: this.selectForm.marriage,
        carPurchase: this.selectForm.carPurchase,
        buyHouse: this.selectForm.buyHouse,
        education: this.selectForm.education,
        noOrPhone: this.selectForm.noOrPhone,
        authentication: this.selectForm.authentication,
        agpName: this.selectForm.agpName,
        membership: this.selectForm.membership
      };
      if (this.selectForm.selectCitys.length > 0) {
        par.province = this.selectForm.selectCitys[0];
        par.city = this.selectForm.selectCitys[1];
        if (this.selectForm.selectCitys.length > 2) {
          par.area = this.selectForm.selectCitys[2];
        }
      }
      if (this.selectForm.registerTime.length >= 2) {
        par.registerStartTime = this.selectForm.registerTime[0];
        par.registerEndTime = this.selectForm.registerTime[1];
      }
      if (this.selectForm.memberTime.length >= 2) {
        par.memberSelStartTime = this.selectForm.memberTime[0];
        par.memberSelEndTime = this.selectForm.memberTime[1];
      }
      var apiUrl = 'admin/v1/member/exportAgencyMemberTouristsPageList';
      this.downloadUtil.excelExport(apiUrl, par, '访客统计表.xls');
    },
    changeAuthentications: function changeAuthentications(type) {
      return this.enums.checkEnumsValue(this.getAuthentications, type, '-');
    },
    changeVac: function changeVac(type) {
      return this.enums.checkEnumsValue(this.memberV, type, '-');
    },
    changeMemberType: function changeMemberType(type) {
      return this.enums.checkEnumsValue(this.memberTypes, type, '-');
    },
    changeSex: function changeSex(type) {
      return this.enums.checkEnumsValue(this.sex, type, '-');
    },
    addWarning: function addWarning() {
      var _this = this;
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
      } else {
        this.$confirm('确定警告该用户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var data = {
            memberIds: par,
            warningsNum: 1
          };
          _this.addWarningApi(data);
        }).catch(function () {
          _this.$message({
            type: 'info',
            message: '已取消修改'
          });
        });
      }
    },
    openAddMember: function openAddMember() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addMembeDialogVisible = true;
      this.$refs.addMember.setTitle('开通会员');
      this.$refs.addMember.initData(par);
    },
    addMemberClose: function addMemberClose() {
      this.addMembeDialogVisible = false;
    },
    openPushMessage: function openPushMessage() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.pushMessageDialogVisible = true;
      this.$refs.pushMessage.setTitle('推送消息');
      this.$refs.pushMessage.initMemberData(par);
    },
    pushMessageClose: function pushMessageClose() {
      this.pushMessageDialogVisible = false;
    },
    openAddCurrency: function openAddCurrency() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addCurrencyDialogVisible = true;
      this.$refs.addCurrency.setTitle('增币');
      this.$refs.addCurrency.initData(par);
    },
    addCurrencyClose: function addCurrencyClose() {
      this.addCurrencyDialogVisible = false;
    },
    sortChange: function sortChange(op) {
      this.pageNo = 1;
      if (op === 'default') {
        this.selectForm.sortType = 1;
      } else if (op === 'activity') {
        this.selectForm.sortType = 2;
      } else if (op === 'fans') {
        this.selectForm.sortType = 3;
      } else if (op === 'recharge') {
        this.selectForm.sortType = 4;
      }
      this.initTableData();
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.getSexEnumList('member_sex');
      this.getMemberVList('member_v');
      this.getMemberTypeList('member_type');
      this.getMemberSourcesList('member_source');
      this.getMemberAgeEnumList();
      this.getEducationsEnumList();
      this.getBuyHousesEnumList();
      this.getMarriagesEnumList();
      this.getCarPurchasesEnumList();
      this.enums.getAuthentication(function (res) {
        thiz.getAuthentications = res.body;
      });
    },
    getCarPurchasesEnumList: function getCarPurchasesEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: 'member_car_select'
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this2.carPurchases = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this3.marriages = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getBuyHousesEnumList: function getBuyHousesEnumList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'member_buyHouse_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this4.buyHouses = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getEducationsEnumList: function getEducationsEnumList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: 'mbmber_education_select'
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this5.educations = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getMemberAgeEnumList: function getMemberAgeEnumList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res, data, index, item, values, min, max, datas, i;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: 'member_age_select'
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              data = res.body;
              for (index in data) {
                item = data[index];
                values = item.values.split('-');
                min = values[0];
                max = values[1];
                datas = [];
                for (i = parseInt(min); i <= parseInt(max); i++) {
                  datas.push(i);
                }
                if (item.keys === 'max') {
                  _this6.maxAges = datas;
                } else {
                  _this6.minAges = datas;
                }
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getMemberSourcesList: function getMemberSourcesList(name) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                name: name
              };
              _context6.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context6.v;
              _this7.memberSources = res.body;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getMemberTypeList: function getMemberTypeList(name) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                name: name
              };
              _context7.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context7.v;
              _this8.memberTypes = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getMemberVList: function getMemberVList(name) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              par = {
                name: name
              };
              _context8.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context8.v;
              _this9.memberV = res.body;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    getSexEnumList: function getSexEnumList(name) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var par, res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              par = {
                name: name
              };
              _context9.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context9.v;
              _this0.sex = res.body;
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this1 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this1.daleteApi(index, data);
      }).catch(function () {
        _this1.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var par;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              par = {
                memberId: data.memberId
              };
              _context0.n = 1;
              return api.DELETE_MEMBER(par);
            case 1:
              _this10.initTableData();
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return api.DELETE_BATCH_MEMBER(par);
            case 1:
              _this11.$message.success('操作成功');
              _this11.initTableData();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this12 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this12.tableSelects.forEach(function (element) {
          par.push(element.memberId);
        });
        _this12.deleteBatchApi(par);
      }).catch(function () {
        _this12.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('会员详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.endAge = null;
      this.selectForm.startAge = null;
      this.selectForm.registerTime = [];
      this.selectForm.memberTime = [];
      this.selectForm.nickName = '';
      this.selectForm.sex = '';
      this.selectForm.name = '';
      this.selectForm.headUrl = '';
      this.selectForm.phone = '';
      this.selectForm.userName = '';
      this.selectForm.passWord = '';
      this.selectForm.wxMiniOpenid = '';
      this.selectForm.loginTime = null;
      this.selectForm.loginNum = null;
      this.selectForm.loginDevice = '';
      this.selectForm.province = '';
      this.selectForm.city = '';
      this.selectForm.area = '';
      this.selectForm.longitude = '';
      this.selectForm.latitude = '';
      this.selectForm.vAuth = '';
      this.selectForm.memberType = '';
      this.selectForm.privateLetterNum = null;
      this.selectForm.acceptNum = null;
      this.selectForm.memberStartTime = null;
      this.selectForm.memberEndTime = null;
      this.selectForm.warningsNum = null;
      this.selectForm.currencyNum = null;
      this.selectForm.memberSts = null;
      this.selectForm.createTime = null;
      this.selectForm.memberNo = '';
      this.selectForm.source = '';
      this.selectForm.marriage = '';
      this.selectForm.carPurchase = '';
      this.selectForm.buyHouse = '';
      this.selectForm.education = '';
      this.selectForm.noOrPhone = '';
      this.selectForm.agpName = null;
      this.selectForm.selectCitys = [];
      this.selectForm.authentication = '';
      this.selectForm.membership = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var par, res;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              par = {
                pageNo: _this13.pageNo,
                pageSize: _this13.pageSize,
                nickName: _this13.selectForm.nickName,
                sex: _this13.selectForm.sex,
                name: _this13.selectForm.name,
                headUrl: _this13.selectForm.headUrl,
                phone: _this13.selectForm.phone,
                userName: _this13.selectForm.userName,
                vAuth: _this13.selectForm.vAuth,
                memberType: _this13.selectForm.memberType,
                privateLetterNum: _this13.selectForm.privateLetterNum,
                acceptNum: _this13.selectForm.acceptNum,
                memberStartTime: _this13.selectForm.memberStartTime,
                memberEndTime: _this13.selectForm.memberEndTime,
                warningsNum: _this13.selectForm.warningsNum,
                currencyNum: _this13.selectForm.currencyNum,
                memberSts: _this13.selectForm.memberSts,
                memberNo: _this13.selectForm.memberNo,
                source: _this13.selectForm.source,
                sortType: _this13.selectForm.sortType,
                endAge: _this13.selectForm.endAge,
                startAge: _this13.selectForm.startAge,
                marriage: _this13.selectForm.marriage,
                carPurchase: _this13.selectForm.carPurchase,
                buyHouse: _this13.selectForm.buyHouse,
                education: _this13.selectForm.education,
                noOrPhone: _this13.selectForm.noOrPhone,
                authentication: _this13.selectForm.authentication,
                agpName: _this13.selectForm.agpName,
                membership: _this13.selectForm.membership
              };
              if (_this13.selectForm.selectCitys.length > 0) {
                par.province = _this13.selectForm.selectCitys[0];
                par.city = _this13.selectForm.selectCitys[1];
                if (_this13.selectForm.selectCitys.length > 2) {
                  par.area = _this13.selectForm.selectCitys[2];
                }
              }
              if (_this13.selectForm.registerTime.length >= 2) {
                par.registerStartTime = _this13.selectForm.registerTime[0];
                par.registerEndTime = _this13.selectForm.registerTime[1];
              }
              if (_this13.selectForm.memberTime.length >= 2) {
                par.memberSelStartTime = _this13.selectForm.memberTime[0];
                par.memberSelEndTime = _this13.selectForm.memberTime[1];
              }
              _context10.n = 1;
              return api.GET_AGENCY_MEMBER_TOURISTS_PAGE_LIST(par);
            case 1:
              res = _context10.v;
              _this13.tableData = res.body.datas;
              _this13.pageTotal = res.body.sumDataCount;
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    initProvinces: function initProvinces() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return api.GET_PROVINCE_LIST();
            case 1:
              res = _context11.v;
              _this14.provinces = res.body;
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    initCitys: function initCitys() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context12.v;
              _this15.citys = res.body;
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    addWarningApi: function addWarningApi(data) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return api.ADD_MEMBER_WARNING(data);
            case 1:
              Message.success('操作成功');
              _this16.initTableData();
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initCitys();
    this.initEunmData();
    this.initTableData();
  }
};